import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';

export const AlertInfo = ({ alertText }) => {
  return (
    <p className="alert-info">
      <span className="icon-box">
        <i className="ic-info-solid-gray sm" />
      </span>
      <span className="text">{i18n.t(alertText)}</span>
    </p>
  );
};
AlertInfo.propTypes = { alertText: PropTypes.string };
AlertInfo.defaultProps = { alertText: '' };
export default AlertInfo;
